var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            visible: _vm.queryHelperOpen,
            size: "xl",
            title: "Guided Query Builder",
            "body-class": "pb-4",
            "hide-footer": "",
            "no-close-on-backdrop": "",
          },
          on: {
            change: function ($event) {
              return _vm.$emit("update:queryHelperOpen", $event)
            },
          },
        },
        [
          _c("div", { staticClass: "small text-muted mb-3" }, [
            _vm._v(
              " Build a targeted search from CFDE evidence. The AI will draft both a scientifically grounded query and a research context you can review before search. "
            ),
          ]),
          _c("div", { staticClass: "form-group mb-3" }, [
            _c("label", { staticClass: "font-weight-bold mb-1" }, [
              _vm._v("1. Select Target Phenotype or Disease"),
            ]),
            _c("div", { staticClass: "small text-muted mb-1" }, [
              _vm._v(
                " Start by anchoring your search to a specific physiological trait or disease state (e.g., Waist-to-hip ratio, Type 2 Diabetes). "
              ),
            ]),
            _c("input", {
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: "Type to search CFDE phenotypes...",
              },
              domProps: { value: _vm.queryHelperPhenotypeInput },
              on: {
                input: function ($event) {
                  return _vm.$emit(
                    "update:queryHelperPhenotypeInput",
                    $event.target.value
                  )
                },
              },
            }),
            _vm.queryHelperPhenotypeSuggestions.length
              ? _c(
                  "ul",
                  {
                    staticClass:
                      "query-helper-suggest-list list-unstyled mt-2 mb-2 border rounded",
                  },
                  _vm._l(_vm.queryHelperPhenotypeSuggestions, function (opt) {
                    return _c(
                      "li",
                      {
                        key: "qh-pheno-" + opt.value,
                        staticClass: "query-helper-suggest-item px-2 py-1",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-link btn-sm p-0 text-left w-100",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.helpers.onQueryHelperPickPhenotype(
                                  opt
                                )
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v(_vm._s(opt.label)),
                            ]),
                            _c("span", { staticClass: "text-muted" }, [
                              _vm._v(" (" + _vm._s(opt.value) + ")"),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.queryHelperSelectedPhenotypes.length
              ? _c(
                  "div",
                  { staticClass: "d-flex flex-wrap mt-2" },
                  _vm._l(_vm.queryHelperSelectedPhenotypes, function (item) {
                    return _c(
                      "span",
                      {
                        key: "qh-pheno-chip-" + item.value,
                        staticClass: "pill query-helper-pill mr-2 mb-2",
                      },
                      [
                        _vm._v(" " + _vm._s(item.label) + " "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sm p-0 ml-1",
                            attrs: {
                              type: "button",
                              "aria-label": "Remove phenotype",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.helpers.removeQueryHelperPhenotype(
                                  item.value
                                )
                              },
                            },
                          },
                          [_vm._v(" × ")]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.queryHelperNoFactorPhenotypeLabels.length
              ? _c("div", { staticClass: "small text-warning mt-1" }, [
                  _vm._v(
                    " No gene set clusters returned for: " +
                      _vm._s(
                        _vm.queryHelperNoFactorPhenotypeLabels.join(", ")
                      ) +
                      ". "
                  ),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "mb-1 font-weight-bold" }, [
            _vm._v("2. Select Biological Mechanisms (Gene set clusters)"),
          ]),
          _vm.queryHelperFactorRows.length
            ? _c("div", { staticClass: "small text-muted mb-2" }, [
                _vm._v(
                  " Select 1-2 pathways to force the AI to investigate these specific mechanisms. "
                ),
              ])
            : _vm._e(),
          _vm.queryHelperLoadingFactors
            ? _c(
                "div",
                {
                  staticClass:
                    "small text-muted d-flex align-items-center mb-3",
                },
                [
                  _c("b-spinner", {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                  }),
                  _vm._v(
                    " Loading gene set clusters for selected phenotypes... "
                  ),
                ],
                1
              )
            : _vm.queryHelperFactorError
            ? _c("div", { staticClass: "alert alert-warning py-2 mb-3" }, [
                _vm._v(" " + _vm._s(_vm.queryHelperFactorError) + " "),
              ])
            : _vm.queryHelperFactorRows.length
            ? _c("div", { staticClass: "mb-3" }, [
                _c("div", { staticClass: "form-group mb-2" }, [
                  _c("input", {
                    staticClass: "form-control form-control-sm",
                    attrs: {
                      type: "text",
                      placeholder:
                        "Filter gene set clusters (comma-separated keywords)",
                    },
                    domProps: { value: _vm.queryHelperClusterFilterInput },
                    on: {
                      input: function ($event) {
                        _vm.$emit(
                          "update:queryHelperClusterFilterInput",
                          $event.target.value
                        )
                        _vm.helpers.applyQueryHelperClusterFilterSelection()
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "table-responsive" }, [
                  _c(
                    "table",
                    { staticClass: "table table-sm table-striped mb-0" },
                    [
                      _c("thead", { staticClass: "thead-light" }, [
                        _c("tr", [
                          _c("th", { staticStyle: { width: "90px" } }, [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c("input", {
                                  staticClass:
                                    "query-helper-factor-checkbox mr-2",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: _vm.queryHelperAllFactorsSelected,
                                    indeterminate:
                                      _vm.queryHelperSomeFactorsSelected,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.helpers.toggleQueryHelperAllFactors(
                                        $event
                                      )
                                    },
                                  },
                                }),
                                _c("span", [_vm._v("Select")]),
                              ]
                            ),
                          ]),
                          _c("th", { staticStyle: { width: "260px" } }, [
                            _vm._v("Phenotype"),
                          ]),
                          _c("th", [_vm._v("Gene set cluster")]),
                        ]),
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_vm.queryHelperFactorPageRows, function (row) {
                          return _c("tr", { key: "qh-factor-" + row.key }, [
                            _c("td", [
                              _c("input", {
                                staticClass: "query-helper-factor-checkbox",
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked:
                                    !!_vm.queryHelperFactorSelection[row.key],
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.helpers.toggleQueryHelperFactor(
                                      row.key,
                                      $event
                                    )
                                  },
                                },
                              }),
                            ]),
                            _c("td", [_vm._v(_vm._s(row.phenotypeLabel))]),
                            _c("td", [_vm._v(_vm._s(row.factorLabel))]),
                          ])
                        }),
                        0
                      ),
                    ]
                  ),
                ]),
                _vm.queryHelperFactorRows.length > _vm.queryHelperFactorsPerPage
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-content-end mt-2" },
                      [
                        _c("b-pagination", {
                          attrs: {
                            value: _vm.queryHelperFactorPage,
                            "total-rows": _vm.queryHelperFactorRows.length,
                            "per-page": _vm.queryHelperFactorsPerPage,
                            size: "sm",
                            pills: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$emit(
                                "update:queryHelperFactorPage",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _c("div", { staticClass: "small text-muted mb-3" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.queryHelperSelectedPhenotypes.length
                        ? "No associated gene set clusters returned for selected phenotypes."
                        : "First, select a phenotype above to view its associated biological mechanisms and pathways."
                    ) +
                    " "
                ),
              ]),
          _c("div", { staticClass: "form-group mb-3" }, [
            _c("label", { staticClass: "font-weight-bold mb-1" }, [
              _vm._v("Additional mechanism terms (optional)"),
            ]),
            _c("div", { staticClass: "small text-muted mb-1" }, [
              _vm._v(
                " Add extra mechanism keywords not captured by selected pathways. "
              ),
            ]),
            _c("input", {
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: "Add an extra mechanism term, then press Enter",
              },
              domProps: { value: _vm.queryHelperMechanismInput },
              on: {
                input: function ($event) {
                  return _vm.$emit(
                    "update:queryHelperMechanismInput",
                    $event.target.value
                  )
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                  return _vm.helpers.addQueryHelperMechanismFromInput.apply(
                    null,
                    arguments
                  )
                },
              },
            }),
            _vm.queryHelperMechanismTerms.length
              ? _c(
                  "div",
                  { staticClass: "d-flex flex-wrap mt-2" },
                  _vm._l(_vm.queryHelperMechanismTerms, function (term) {
                    return _c(
                      "span",
                      {
                        key: "qh-mech-chip-" + term,
                        staticClass: "pill query-helper-pill mr-2 mb-2",
                      },
                      [
                        _vm._v(" " + _vm._s(term) + " "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sm p-0 ml-1",
                            attrs: {
                              type: "button",
                              "aria-label": "Remove mechanism term",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.helpers.removeQueryHelperMechanism(
                                  term
                                )
                              },
                            },
                          },
                          [_vm._v(" × ")]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "form-group mb-3" }, [
            _c("label", { staticClass: "font-weight-bold mb-1" }, [
              _vm._v("3. Pin Specific Genes (Optional)"),
            ]),
            _c("div", { staticClass: "small text-muted mb-1" }, [
              _vm._v(
                " Leave empty to let the AI discover contextually novel genes. Pin specific genes to force the network to build a pathway around them. "
              ),
            ]),
            _c("input", {
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: "Search and select a gene symbol",
              },
              domProps: { value: _vm.queryHelperGeneInput },
              on: {
                input: function ($event) {
                  _vm.$emit("update:queryHelperGeneInput", $event.target.value)
                  _vm.helpers.onQueryHelperGeneInput()
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                  return _vm.helpers.addQueryHelperGeneFromInput.apply(
                    null,
                    arguments
                  )
                },
              },
            }),
            _vm.queryHelperGeneSuggestions.length
              ? _c(
                  "ul",
                  {
                    staticClass:
                      "query-helper-suggest-list list-unstyled mt-2 mb-2 border rounded",
                  },
                  _vm._l(_vm.queryHelperGeneSuggestions, function (gene) {
                    return _c(
                      "li",
                      {
                        key: "qh-gene-suggest-" + gene,
                        staticClass: "query-helper-suggest-item px-2 py-1",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-link btn-sm p-0 text-left w-100",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.helpers.selectQueryHelperGeneSuggestion(
                                  gene
                                )
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(gene) + " ")]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.queryHelperGenesOfInterest.length
              ? _c(
                  "div",
                  { staticClass: "d-flex flex-wrap mt-2" },
                  _vm._l(_vm.queryHelperGenesOfInterest, function (gene) {
                    return _c(
                      "span",
                      {
                        key: "qh-gene-chip-" + gene,
                        staticClass: "pill query-helper-pill mr-2 mb-2",
                      },
                      [
                        _vm._v(" " + _vm._s(gene) + " "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sm p-0 ml-1",
                            attrs: {
                              type: "button",
                              "aria-label": "Remove gene",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.helpers.removeQueryHelperGene(gene)
                              },
                            },
                          },
                          [_vm._v(" × ")]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _vm.queryHelperCanContinue
            ? _c("div", { staticClass: "form-group mb-3" }, [
                _c("label", { staticClass: "font-weight-bold mb-1" }, [
                  _vm._v("Research context (optional draft)"),
                ]),
                _c("textarea", {
                  staticClass: "form-control",
                  attrs: {
                    rows: "3",
                    placeholder:
                      "Optional: add context you want included when composing your query.",
                  },
                  domProps: { value: _vm.queryHelperDraftResearchContext },
                  on: {
                    input: function ($event) {
                      return _vm.$emit(
                        "update:queryHelperDraftResearchContext",
                        $event.target.value
                      )
                    },
                  },
                }),
              ])
            : _vm._e(),
          _vm.queryHelperCanContinue
            ? _c("div", { staticClass: "form-group mb-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-link p-0 d-flex align-items-center",
                    staticStyle: { gap: "0.35rem" },
                    attrs: {
                      type: "button",
                      "aria-expanded": _vm.queryHelperAdvancedOpen
                        ? "true"
                        : "false",
                      "aria-controls":
                        "query-helper-advanced-retrieval-options",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit(
                          "update:queryHelperAdvancedOpen",
                          !_vm.queryHelperAdvancedOpen
                        )
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v("Advanced retrieval options"),
                    ]),
                    _c("b-icon", {
                      attrs: {
                        icon: _vm.queryHelperAdvancedOpen
                          ? "chevron-up"
                          : "chevron-down",
                        "aria-hidden": "true",
                      },
                    }),
                  ],
                  1
                ),
                _vm.queryHelperAdvancedOpen
                  ? _c(
                      "div",
                      {
                        staticClass: "mt-2 border rounded p-2",
                        attrs: {
                          id: "query-helper-advanced-retrieval-options",
                        },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "d-flex align-items-center mb-1",
                            staticStyle: { gap: "0.5rem" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                disabled:
                                  !_vm.queryHelperHardConstraintEligible,
                              },
                              domProps: {
                                checked: _vm.queryHelperHardConstraintEnabled,
                              },
                              on: {
                                change: function ($event) {
                                  _vm.$emit(
                                    "update:queryHelperHardConstraintEnabled",
                                    !!(
                                      $event &&
                                      $event.target &&
                                      $event.target.checked
                                    )
                                  )
                                },
                              },
                            }),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v(
                                "Use helper selections as hard retrieval constraints"
                              ),
                            ]),
                          ]
                        ),
                        _c("div", { staticClass: "small text-muted" }, [
                          _vm._v(
                            " Next, the LLM will extract search terms and generate research context for retrieval. When this option is enabled, your selected phenotype and gene set cluster choices are still enforced during data retrieval. "
                          ),
                        ]),
                        !_vm.queryHelperHardConstraintEligible
                          ? _c(
                              "div",
                              { staticClass: "small text-muted mt-1" },
                              [
                                _vm._v(
                                  " This option becomes available after selecting at least one phenotype and one gene set cluster. "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mt-2",
            },
            [
              _vm.queryHelperError
                ? _c("div", { staticClass: "small text-danger" }, [
                    _vm._v(_vm._s(_vm.queryHelperError)),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "ml-auto d-flex align-items-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary mr-2",
                    attrs: {
                      type: "button",
                      disabled: _vm.queryHelperComposing,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("update:queryHelperOpen", false)
                      },
                    },
                  },
                  [_vm._v(" Cancel ")]
                ),
                _vm.queryHelperCanContinue
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-cfde",
                        attrs: {
                          type: "button",
                          disabled: _vm.queryHelperComposing,
                        },
                        on: { click: _vm.helpers.continueWithQueryHelper },
                      },
                      [
                        _vm.queryHelperComposing
                          ? _c(
                              "span",
                              [
                                _c("b-spinner", {
                                  staticClass: "mr-1",
                                  attrs: { small: "" },
                                }),
                                _vm._v(" Building... "),
                              ],
                              1
                            )
                          : _c("span", [_vm._v("Draft Query + Context")]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          ),
          _vm.queryHelperCanContinue
            ? _c("div", { staticClass: "small text-muted text-right mt-1" }, [
                _vm._v(
                  " You can review and edit the drafted query and context before searching. "
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }